function SvgComponent(props: any) {
    return (
      <svg
        width={147}
        height={96}
        viewBox="0 0 147 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57 9.5A9.5 9.5 0 0166.5 0h30a9.5 9.5 0 019.5 9.5 9.5 9.5 0 01-9.5 9.5h-.24a9.778 9.778 0 015 8.535c0 5.402-4.379 9.78-9.78 9.78H126c5.402 0 9.781 4.38 9.781 9.781 0 5.402-4.379 9.781-9.781 9.781H88.036c5.398.005 9.772 4.382 9.772 9.781 0 5.402-4.379 9.78-9.78 9.78h48.328c5.402 0 9.781 4.38 9.781 9.782 0 5.401-4.379 9.78-9.781 9.78H58.11c-5.402 0-9.781-4.379-9.781-9.78 0-5.402 4.379-9.781 9.78-9.781H30.494c-5.402 0-9.78-4.38-9.78-9.781 0-5.402 4.378-9.78 9.78-9.78h13.8c-5.398-.005-9.773-4.383-9.773-9.782 0-5.401 4.38-9.78 9.781-9.78H9.781C4.379 37.316 0 32.936 0 27.535c0-5.402 4.379-9.781 9.78-9.781h52.013A9.497 9.497 0 0157 9.5z"
          fill="#FFF0F0"
        />
        <ellipse cx={10.5} cy={50} rx={2.5} ry={2} fill="#EB5757" />
        <ellipse cx={42.5} cy={89} rx={2.5} ry={2} fill="#EB5757" />
        <path
          d="M135.703 62.854l-.203-.281-.203.28-2.165 3-.286.397h5.308l-.286-.396-2.165-3zM110.717 11.875l-.217-.375-.217.375-2.165 3.75-.216.375h5.196l-.216-.375-2.165-3.75z"
          stroke="#EB5757"
          strokeWidth={0.5}
        />
        <path
          d="M63 28a5 5 0 00-5 5v13.017a13.698 13.698 0 012.5-.462V33a2.5 2.5 0 012.5-2.5h10v8.75A3.75 3.75 0 0076.75 43h8.75v20a2.5 2.5 0 01-2.5 2.5h-9a13.768 13.768 0 01-1.642 2.5H83a5 5 0 005-5V41.535a3.75 3.75 0 00-1.1-2.65l-9.785-9.787A3.75 3.75 0 0074.465 28H63zm21.983 12.5H76.75a1.25 1.25 0 01-1.25-1.25v-8.233l9.483 9.483zM73 59.25a11.25 11.25 0 11-22.5 0 11.25 11.25 0 0122.5 0zm-5.365-4.635a1.25 1.25 0 00-1.77 0l-6.615 6.617-1.615-1.617a1.252 1.252 0 00-1.77 1.77l2.5 2.5a1.25 1.25 0 001.77 0l7.5-7.5a1.25 1.25 0 000-1.77z"
          fill="#EB5757"
        />
        <circle cx={62} cy={59} r={12} fill="#F4F4F4" />
        <path
          d="M62 69a9.733 9.733 0 01-3.9-.788 10.092 10.092 0 01-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 0152 59c0-1.383.263-2.683.788-3.9a10.092 10.092 0 012.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0162 49c1.383 0 2.683.262 3.9.787a10.105 10.105 0 013.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0172 59a9.733 9.733 0 01-.788 3.9 10.092 10.092 0 01-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0162 69zm-3.6-5l3.6-3.6 3.6 3.6 1.4-1.4-3.6-3.6 3.6-3.6-1.4-1.4-3.6 3.6-3.6-3.6-1.4 1.4 3.6 3.6-3.6 3.6 1.4 1.4z"
          fill="#EB5757"
        />
      </svg>
    )
  }
  
  export default SvgComponent